(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
class AnnouncementBar extends HTMLElement {
    constructor() {
        super();
        this.closeIcon = document.querySelector('[data-announcement-close-icon]');
        this.cookie = document.cookie.split('; ').find((index) => index === 'hide-announcement-bar=true');
        if (this.cookie) {
            document.body.classList.add('hide-announcement-bar');
        }
        else {
            document.body.classList.add('show-announcement-bar');
            this.closeIcon.addEventListener('click', () => {
                document.body.classList.add('hide-announcement-bar');
                document.cookie = 'hide-announcement-bar=true';
            });
        }
    }
}
customElements.define('announcement-bar', AnnouncementBar);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-text-block"] && !window.DesignMode) return;
  try {
    
class FeaturedTextBlock extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('featured-text-block', FeaturedTextBlock);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["four-col-product-listing"] && !window.DesignMode) return;
  try {
    
  class FourColProductListing extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        if (this.dataset.url) {
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('four-col-product-listing');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('four-col-product-listing', FourColProductListing);

  class CustomSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('ul');
      this.sliderItems = this.querySelectorAll('li');
      this.pageCount = this.querySelector('.slider-counter--current');
      this.pageTotal = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;
  
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
  
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    }
  
    initPages() {
      if (!this.sliderItems.length === 0) return;
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
      this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
      this.update();
    }
  
    update() {
      if (!this.pageCount || !this.pageTotal) return;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;
  
      if (this.currentPage === 1) {
        this.prevButton.setAttribute('disabled', true);
      } else {
        this.prevButton.removeAttribute('disabled');
      }
  
      if (this.currentPage === this.totalPages) {
        this.nextButton.setAttribute('disabled', true);
      } else {
        this.nextButton.removeAttribute('disabled');
      }
  
      this.pageCount.textContent = this.currentPage;
      this.pageTotal.textContent = this.totalPages;
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  
  customElements.define('custom-slider-component', CustomSliderComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["full-width-slider"] && !window.DesignMode) return;
  try {
    
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// TODO: import this function using webpack
const videoObserver = (array) => {
    array.map((instance) => {
        if (instance && instance.tagName === 'VIDEO') {
            const threshold = 0.1;
            let isPaused = false;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio < threshold) {
                        if (instance && !instance.paused) {
                            instance.pause();
                        }
                        isPaused = true;
                    }
                    else if (isPaused) {
                        if (instance && instance.paused) {
                            instance.play();
                        }
                        isPaused = false;
                    }
                });
            }, {
                root: null,
                rootMargin: '20px',
                threshold: threshold,
            });
            observer.observe(instance);
        }
    });
};
document.addEventListener('DOMContentLoaded', () => __awaiter(this, void 0, void 0, function* () {
    //Dynamicly import flickity
    yield import(window.assetsURL + 'flickity.pkgd.min.js');
    //Load required flickity styles
    window.loadCssIfNotLoaded(window.assetsURL + 'flickity.min.css');
    //Force slider to scroll to the left to avoid issue when a hash for a slide is in the url causing the slider to be moved to the right showing blank slides
    window.addEventListener('load', () => {
        const fwSliders = document.querySelectorAll('[data-fw-slider]');
        if (fwSliders.length > 0) {
            [...fwSliders].map((fwSlider) => {
                const fwSliderContainer = fwSlider.querySelector('.fw-slider__container');
                const videoObservers = fwSlider.querySelectorAll('[data-video-observer]');
                if (videoObservers.length > 0) {
                    videoObserver([...videoObservers]);
                }
                if (fwSliderContainer) {
                    requestAnimationFrame(() => {
                        fwSliderContainer.scrollLeft = 0;
                    });
                }
            });
        }
    });
}));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  var headerElement = document.querySelector('header');  
  // If header element exists and the transparent-header attribute is set to "true"
  var transparentHeader =  headerElement.getAttribute("transparent-header");
 // console.log("Location: " + window.location.href + " | Transparent Header: " + transparentHeader);
  var isFwSlider = $('.HomePage_banner-one').hasClass('fw-slider');
  var headerSection = document.getElementById('shopify-section-header');
  var location = window.location.href;
  if (transparentHeader == "true") {
    if (headerSection) {
      if (isFwSlider && location === "https://cushlawhiting.com.au/" ||isFwSlider && location === "https://cushlawhiting.com.au/?_ab=0&_fd=0&_sc=1") {
        headerSection.classList.add("main_banner");
      } else {
        headerSection.classList.remove("main_banner");
      }
     
    }
  } else{
    //console.log("hi this is false")
    // Add main_banner class if transparentHeader is "false"
    if (isFwSlider && location === "https://cushlawhiting.com.au/" ||isFwSlider && location === "https://cushlawhiting.com.au/?_ab=0&_fd=0&_sc=1" ) {
        headerSection.classList.remove("main_banner");
      } else {
        // On all other pages (including product collections, etc.), remove the class
        headerSection.classList.remove("main_banner");
      }

  }
});

 

  class StickyHeader extends HTMLElement {
    isOpen = false;
    constructor() {
      super();
      this.isOpen = false;
      this.header = document.getElementById('shopify-section-header');
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if(!this.isOpen) {
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if(!this.isOpen) {
        requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        if(!this.isOpen) {
        requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');      
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-listing"] && !window.DesignMode) return;
  try {
    
class IconListing extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('icon-listing', IconListing);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bespoke"]) return;
  try {
    
  
  
  const thumbnails = document.querySelectorAll('[data-product-thumbnail]');
  const flkty = new Flickity('.product__media-list', { prevNextButtons: false, watchCSS: true });

  if (thumbnails.length > 0) {
    [...thumbnails].forEach((thumbnail) => {
      thumbnail.addEventListener('click', (e) => {
        const slideNumber = e.currentTarget.dataset.productThumbnail;
        flkty.selectCell(`.product__media-item--${slideNumber}`);
      });
    });

    flkty.on('select', (index) => {
      [...thumbnails].map((thumb) => {
        thumb.classList.remove('active');
      });
      document.querySelector(`[data-product-thumbnail="${index}"]`).classList.add('active');
    });
  }
  class ProductSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('ul');
      this.sliderItems = this.querySelectorAll('li');
      this.pageCount = this.querySelector('.slider-counter--current');
      this.pageTotal = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.nextButton) return;

      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
      if (!this.sliderItems.length === 0) return;
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
      this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
      this.update();
    }

    update() {
      if (!this.pageCount || !this.pageTotal) return;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

      if (this.currentPage === 1) {
        this.prevButton.setAttribute('disabled', true);
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.currentPage === this.totalPages) {
        this.nextButton.setAttribute('disabled', true);
      } else {
        this.nextButton.removeAttribute('disabled');
      }

      this.pageCount.textContent = this.currentPage;
      this.pageTotal.textContent = this.totalPages;
    }

    onButtonClick(event) {
      event.preventDefault();
      const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }

  customElements.define('product-slider-component', ProductSliderComponent);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);
  var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
//On bespoke form existence, set the product reference value
document.addEventListener('DOMContentLoaded', () => __awaiter(this, void 0, void 0, function* () {
    const bespokeEnquireButton = document.getElementById('ProductPopup-enquire');
    const bespokeEnquirePopup = document.getElementById('PopupModal-enquire');
    if (bespokeEnquireButton && bespokeEnquirePopup) {
        const enquireForm = bespokeEnquirePopup.querySelector('form');
        if (enquireForm) {
            const contactFormProductField = enquireForm.querySelector('#ContactForm-product');
            if (contactFormProductField) {
                contactFormProductField.value = bespokeEnquireButton.dataset.productReference;
            }
        }
        bespokeEnquireButton.addEventListener('click', () => {
            const enquireForm = bespokeEnquirePopup.querySelector('form');
            const referenceField = document.querySelector('input[placeholder="Product Reference"]');
            const contactFormProductField = enquireForm.querySelector('#ContactForm-product');
            if (contactFormProductField) {
                contactFormProductField.value = bespokeEnquireButton.dataset.productReference;
            }
            if (referenceField) {
                referenceField.setAttribute('autocomplete', 'off');
                referenceField.value = bespokeEnquireButton.dataset.productReference;
                referenceField.dispatchEvent(new Event('change'));
            }
        });
        window.addEventListener('klaviyoForms', function (e) {
            console.log('HKLAVIYO,', e.detail.type);
            if (e.detail.type == 'open') {
                const referenceField = document.querySelector('input[placeholder="Product Reference"]');
                if (referenceField) {
                    referenceField.value = bespokeEnquireButton.dataset.productReference;
                }
                const enquireForm = bespokeEnquirePopup.querySelector('form');
                enquireForm.addEventListener('submit', () => {
                    if (referenceField) {
                        referenceField.value = bespokeEnquireButton.dataset.productReference;
                    }
                });
            }
            if (e.detail.type == 'submit') {
                //TODO: Load calendar
            }
        });
    }
}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gems-diamond"]) return;
  try {
    
  const thumbnails = document.querySelectorAll('[data-product-thumbnail]');
  const flkty = new Flickity('.product__media-list', { prevNextButtons: false, watchCSS: true });

  if (thumbnails.length > 0) {
    [...thumbnails].forEach((thumbnail) => {
      thumbnail.addEventListener('click', (e) => {
        const slideNumber = e.currentTarget.dataset.productThumbnail;
        flkty.selectCell(`.product__media-item--${slideNumber}`);
      });
    });

    flkty.on('select', (index) => {
      [...thumbnails].map((thumb) => {
        thumb.classList.remove('active');
      });
      document.querySelector(`[data-product-thumbnail="${index}"]`).classList.add('active');
    });
  }
  class ProductSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('ul');
      this.sliderItems = this.querySelectorAll('li');
      this.pageCount = this.querySelector('.slider-counter--current');
      this.pageTotal = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.nextButton) return;

      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
      if (!this.sliderItems.length === 0) return;
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
      this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
      this.update();
    }

    update() {
      if (!this.pageCount || !this.pageTotal) return;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

      if (this.currentPage === 1) {
        this.prevButton.setAttribute('disabled', true);
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.currentPage === this.totalPages) {
        this.nextButton.setAttribute('disabled', true);
      } else {
        this.nextButton.removeAttribute('disabled');
      }

      this.pageCount.textContent = this.currentPage;
      this.pageTotal.textContent = this.totalPages;
    }

    onButtonClick(event) {
      event.preventDefault();
      const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }

  customElements.define('product-slider-component', ProductSliderComponent);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);
  var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
//On bespoke form existence, set the product reference value
document.addEventListener('DOMContentLoaded', () => __awaiter(this, void 0, void 0, function* () {
    const bespokeEnquireButton = document.getElementById('ProductPopup-enquire');
    const bespokeEnquirePopup = document.getElementById('PopupModal-enquire');
    if (bespokeEnquireButton && bespokeEnquirePopup) {
        const enquireForm = bespokeEnquirePopup.querySelector('form');
        if (enquireForm) {
            const contactFormProductField = enquireForm.querySelector('#ContactForm-product');
            if (contactFormProductField) {
                contactFormProductField.value = bespokeEnquireButton.dataset.productReference;
            }
        }
        bespokeEnquireButton.addEventListener('click', () => {
            const enquireForm = bespokeEnquirePopup.querySelector('form');
            const referenceField = document.querySelector('input[placeholder="Product Reference"]');
            const contactFormProductField = enquireForm.querySelector('#ContactForm-product');
            if (contactFormProductField) {
                contactFormProductField.value = bespokeEnquireButton.dataset.productReference;
            }
            if (referenceField) {
                referenceField.setAttribute('autocomplete', 'off');
                referenceField.value = bespokeEnquireButton.dataset.productReference;
                referenceField.dispatchEvent(new Event('change'));
            }
        });
        window.addEventListener('klaviyoForms', function (e) {
            console.log('HKLAVIYO,', e.detail.type);
            if (e.detail.type == 'open') {
                const referenceField = document.querySelector('input[placeholder="Product Reference"]');
                if (referenceField) {
                    referenceField.value = bespokeEnquireButton.dataset.productReference;
                }
                const enquireForm = bespokeEnquirePopup.querySelector('form');
                enquireForm.addEventListener('submit', () => {
                    if (referenceField) {
                        referenceField.value = bespokeEnquireButton.dataset.productReference;
                    }
                });
            }
            if (e.detail.type == 'submit') {
                //TODO: Load calendar
            }
        });
    }
}));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gems-stone"]) return;
  try {
    
  
  
  const thumbnails = document.querySelectorAll('[data-product-thumbnail]');
  const flkty = new Flickity('.product__media-list', { prevNextButtons: false, watchCSS: true});

  if (thumbnails.length > 0) {
    [...thumbnails].forEach((thumbnail) => {
      thumbnail.addEventListener('click', (e) => {
        const slideNumber = e.currentTarget.dataset.productThumbnail;
        flkty.selectCell(`.product__media-item--${slideNumber}`);
      });
    });

    flkty.on('select', (index) => {
      [...thumbnails].map((thumb) => {
        thumb.classList.remove('active');
      });
      document.querySelector(`[data-product-thumbnail="${index}"]`).classList.add('active');
    });
  }
  class ProductSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('ul');
      this.sliderItems = this.querySelectorAll('li');
      this.pageCount = this.querySelector('.slider-counter--current');
      this.pageTotal = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.nextButton) return;

      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
      if (!this.sliderItems.length === 0) return;
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
      this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
      this.update();
    }

    update() {
      if (!this.pageCount || !this.pageTotal) return;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

      if (this.currentPage === 1) {
        this.prevButton.setAttribute('disabled', true);
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.currentPage === this.totalPages) {
        this.nextButton.setAttribute('disabled', true);
      } else {
        this.nextButton.removeAttribute('disabled');
      }

      this.pageCount.textContent = this.currentPage;
      this.pageTotal.textContent = this.totalPages;
    }

    onButtonClick(event) {
      event.preventDefault();
      const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }

  customElements.define('product-slider-component', ProductSliderComponent);

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);
  var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
//On bespoke form existence, set the product reference value
document.addEventListener('DOMContentLoaded', () => __awaiter(this, void 0, void 0, function* () {
    const bespokeEnquireButton = document.getElementById('ProductPopup-enquire');
    const bespokeEnquirePopup = document.getElementById('PopupModal-enquire');
    if (bespokeEnquireButton && bespokeEnquirePopup) {
        const enquireForm = bespokeEnquirePopup.querySelector('form');
        if (enquireForm) {
            const contactFormProductField = enquireForm.querySelector('#ContactForm-product');
            if (contactFormProductField) {
                contactFormProductField.value = bespokeEnquireButton.dataset.productReference;
            }
        }
        bespokeEnquireButton.addEventListener('click', () => {
            const enquireForm = bespokeEnquirePopup.querySelector('form');
            const referenceField = document.querySelector('input[placeholder="Product Reference"]');
            const contactFormProductField = enquireForm.querySelector('#ContactForm-product');
            if (contactFormProductField) {
                contactFormProductField.value = bespokeEnquireButton.dataset.productReference;
            }
            if (referenceField) {
                referenceField.setAttribute('autocomplete', 'off');
                referenceField.value = bespokeEnquireButton.dataset.productReference;
                referenceField.dispatchEvent(new Event('change'));
            }
        });
        window.addEventListener('klaviyoForms', function (e) {
            console.log('HKLAVIYO,', e.detail.type);
            if (e.detail.type == 'open') {
                const referenceField = document.querySelector('input[placeholder="Product Reference"]');
                if (referenceField) {
                    referenceField.value = bespokeEnquireButton.dataset.productReference;
                }
                const enquireForm = bespokeEnquirePopup.querySelector('form');
                enquireForm.addEventListener('submit', () => {
                    if (referenceField) {
                        referenceField.value = bespokeEnquireButton.dataset.productReference;
                    }
                });
            }
            if (e.detail.type == 'submit') {
                //TODO: Load calendar
            }
        });
    }
}));




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mega-text-layout"] && !window.DesignMode) return;
  try {
    
class MegaTextLayout extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('mega-text-layout', MegaTextLayout);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-V2"] && !window.DesignMode) return;
  try {
    
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class MultiColumnSliderComponent extends HTMLElement {
    constructor() {
        super();
    }
}
customElements.define('multicolumn-slider-component', MultiColumnSliderComponent);
document.addEventListener('DOMContentLoaded', () => __awaiter(this, void 0, void 0, function* () {
    //Dynamicly import flickity
    yield import(window.assetsURL + 'flickity.pkgd.min.js');
    //Load required flickity styles
    window.loadCssIfNotLoaded(window.assetsURL + 'flickity.min.css');
}));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !window.DesignMode) return;
  try {
    
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class MultiColumnSliderComponent extends HTMLElement {
    constructor() {
        super();
    }
}
customElements.define('multicolumn-slider-component', MultiColumnSliderComponent);
document.addEventListener('DOMContentLoaded', () => __awaiter(this, void 0, void 0, function* () {
    //Dynamicly import flickity
    yield import(window.assetsURL + 'flickity.pkgd.min.js');
    //Load required flickity styles
    window.loadCssIfNotLoaded(window.assetsURL + 'flickity.min.css');
}));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-buttons"]) return;
  try {
    
class ProductInfoButtons extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('product-info-buttons', ProductInfoButtons);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-text-block"]) return;
  try {
    
class ProductTextBlock extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('product-text-block', ProductTextBlock);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-section"] && !window.DesignMode) return;
  try {
    
class TwoColText extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('tabbed-section', TwoColText);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-listing"] && !window.DesignMode) return;
  try {
    
class TeamListing extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('team-listing', TeamListing);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-layout-menu"] && !window.DesignMode) return;
  try {
    
class TextLayoutMenu extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('text-layout-menu', TextLayoutMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-layout-section"] && !window.DesignMode) return;
  try {
    
class TextLayout extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('text-layout', TextLayout);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-layout"] && !window.DesignMode) return;
  try {
    
class TextLayout extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('text-layout', TextLayout);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-col-feature"] && !window.DesignMode) return;
  try {
    
class TwoColFeature extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('two-col-feature', TwoColFeature);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-col-text"] && !window.DesignMode) return;
  try {
    
class TwoColText extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('two-col-text', TwoColText);

  } catch(e) { console.error(e); }
})();
})();
